/**
 * Where Paige's page pictures live: the job's own `/pages` route on the API, same origin as the
 * app, read with the session's cookie like any other picture on the page. The desktop hands the
 * renderer its own `cp-preview://` scheme instead, and its snippet loader takes nothing else
 * (renderer/field-source-preview-cache.ts), so Paige's host says which addresses are its pages
 * (`pagePreviewSource` on the host, shared/host-capabilities.ts). Only an address built here is
 * one: the loader's check stays a check, it is not thrown open to any web address.
 */
const served = new Set<string>();

/** The builder of one channel's page addresses; what it builds is what `isPageAddress` accepts. */
export function pageAddresses(engineOrigin: string, tenant?: string): (path: string) => string {
  const prefix = `${engineOrigin}/pages?path=`;
  served.add(prefix);
  const tenantQuery = tenant ? `&tenant=${encodeURIComponent(tenant)}` : '';
  return (path) => `${prefix}${encodeURIComponent(path)}${tenantQuery}`;
}

/** Whether an address is a page picture one of this tab's channels serves. */
export function isPageAddress(value: string): boolean {
  for (const prefix of served) if (value.startsWith(prefix)) return true;
  return false;
}
